 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a":"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a","absent_list":"absent_list","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e","area":"area","bank":"bank","country":"country","department":"department","designation":"designation","employees":"employees","ex-employees":"ex-employees","leave":"leave","leave_type":"leave_type","month":"month","pf_transaction":"pf_transaction","shift":"shift","transaction":"transaction","user_management":"user_management","attendance_log":"attendance_log","attendance_report":"attendance_report","attendance_summary_report":"attendance_summary_report","bonus_generate":"bonus_generate","bonus_report":"bonus_report","bonus_sheet":"bonus_sheet","company_profile~employee":"company_profile~employee","employee":"employee","increment":"increment","late_list":"late_list","leave_list":"leave_list","leaves":"leaves","loan":"loan","loan_adjustment":"loan_adjustment","loan_balance_report":"loan_balance_report","loan_statement":"loan_statement","loans":"loans","manual-attendances":"manual-attendances","overtime-entry":"overtime-entry","overtime_record":"overtime_record","pay_slip":"pay_slip","pf_balance_report":"pf_balance_report","pf_ledger":"pf_ledger","pf_transaction_record":"pf_transaction_record","present_list":"present_list","promotion":"promotion","salary_generate":"salary_generate","salary_report":"salary_report","salary_sheet":"salary_sheet","shift_management":"shift_management","transaction_record":"transaction_record","access_denied":"access_denied","attendance-process":"attendance-process","company_profile":"company_profile","employee-details":"employee-details","holiday_management":"holiday_management","notice":"notice"}[chunkId]||chunkId) + "." + {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a":"fe31573d","absent_list":"77f1e17e","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"497e0463","area":"e9416a12","bank":"ed2e1748","country":"bf2fd642","department":"2d9a5f2e","designation":"d89eaf55","employees":"d3525590","ex-employees":"4008284c","leave":"b6f04069","leave_type":"1cc1d602","month":"71053ba4","pf_transaction":"bc298476","shift":"7797e4bd","transaction":"8404c03f","user_management":"c344eef6","attendance_log":"ea4446f7","attendance_report":"083e890a","attendance_summary_report":"49ee2f5c","bonus_generate":"c407e5d5","bonus_report":"17c22a8f","bonus_sheet":"b9d7deaa","company_profile~employee":"100ad609","employee":"50d1985f","increment":"04d7a50e","late_list":"6d3c0726","leave_list":"0bf67158","leaves":"44f31740","loan":"57b28d1c","loan_adjustment":"97d185d2","loan_balance_report":"d83a8fc9","loan_statement":"8d21dc50","loans":"acb773a0","manual-attendances":"ff9a15db","overtime-entry":"45e0b091","overtime_record":"75c2c7cd","pay_slip":"5130820d","pf_balance_report":"e8028b6e","pf_ledger":"dddc3acd","pf_transaction_record":"fe04e17d","present_list":"e985f170","promotion":"a986a313","salary_generate":"93ff210d","salary_report":"27d9228c","salary_sheet":"f9f68ab9","shift_management":"43835840","transaction_record":"e20c214e","access_denied":"b361077f","attendance-process":"cb62bb93","chunk-5442ff1e":"6ea23988","company_profile":"e1c82ad4","employee-details":"e89762f4","holiday_management":"f51ad475","notice":"bc8f81a1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a":1,"absent_list":1,"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":1,"area":1,"bank":1,"country":1,"department":1,"designation":1,"employees":1,"ex-employees":1,"leave":1,"leave_type":1,"month":1,"pf_transaction":1,"shift":1,"transaction":1,"user_management":1,"attendance_log":1,"attendance_report":1,"attendance_summary_report":1,"bonus_generate":1,"bonus_report":1,"bonus_sheet":1,"company_profile~employee":1,"employee":1,"increment":1,"late_list":1,"leave_list":1,"leaves":1,"loan":1,"loan_adjustment":1,"loan_balance_report":1,"loan_statement":1,"loans":1,"manual-attendances":1,"overtime-entry":1,"overtime_record":1,"pay_slip":1,"pf_balance_report":1,"pf_ledger":1,"pf_transaction_record":1,"present_list":1,"promotion":1,"salary_generate":1,"salary_report":1,"salary_sheet":1,"shift_management":1,"transaction_record":1,"attendance-process":1,"chunk-5442ff1e":1,"company_profile":1,"employee-details":1,"holiday_management":1,"notice":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a":"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a","absent_list":"absent_list","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e","area":"area","bank":"bank","country":"country","department":"department","designation":"designation","employees":"employees","ex-employees":"ex-employees","leave":"leave","leave_type":"leave_type","month":"month","pf_transaction":"pf_transaction","shift":"shift","transaction":"transaction","user_management":"user_management","attendance_log":"attendance_log","attendance_report":"attendance_report","attendance_summary_report":"attendance_summary_report","bonus_generate":"bonus_generate","bonus_report":"bonus_report","bonus_sheet":"bonus_sheet","company_profile~employee":"company_profile~employee","employee":"employee","increment":"increment","late_list":"late_list","leave_list":"leave_list","leaves":"leaves","loan":"loan","loan_adjustment":"loan_adjustment","loan_balance_report":"loan_balance_report","loan_statement":"loan_statement","loans":"loans","manual-attendances":"manual-attendances","overtime-entry":"overtime-entry","overtime_record":"overtime_record","pay_slip":"pay_slip","pf_balance_report":"pf_balance_report","pf_ledger":"pf_ledger","pf_transaction_record":"pf_transaction_record","present_list":"present_list","promotion":"promotion","salary_generate":"salary_generate","salary_report":"salary_report","salary_sheet":"salary_sheet","shift_management":"shift_management","transaction_record":"transaction_record","access_denied":"access_denied","attendance-process":"attendance-process","company_profile":"company_profile","employee-details":"employee-details","holiday_management":"holiday_management","notice":"notice"}[chunkId]||chunkId) + "." + {"absent_list~area~attendance_log~attendance_report~attendance_summary_report~bank~bonus_generate~bonu~087df94a":"c48a28e3","absent_list":"2e4eae5f","area~bank~country~department~designation~employees~ex-employees~leave~leave_type~month~pf_transactio~756ee27e":"5ffd811a","area":"033200ff","bank":"033200ff","country":"033200ff","department":"033200ff","designation":"033200ff","employees":"7effc1d1","ex-employees":"b4a7fe05","leave":"3c59c7a7","leave_type":"033200ff","month":"033200ff","pf_transaction":"c50fd3ff","shift":"7bd1a9ce","transaction":"5fc6b2e9","user_management":"35298fd3","attendance_log":"5f2effe6","attendance_report":"cf32b472","attendance_summary_report":"52fee94d","bonus_generate":"2588119f","bonus_report":"32e7548b","bonus_sheet":"178e9895","company_profile~employee":"6df1f26b","employee":"36ed9042","increment":"ca3b45a4","late_list":"f50ba243","leave_list":"2e422567","leaves":"3a78652d","loan":"74f3e34d","loan_adjustment":"8a89cc69","loan_balance_report":"36c0c522","loan_statement":"63d21567","loans":"f350c65e","manual-attendances":"49830f27","overtime-entry":"49830f27","overtime_record":"dd209750","pay_slip":"a1aec03c","pf_balance_report":"5f18ca2c","pf_ledger":"fea9f6d3","pf_transaction_record":"ce433e1b","present_list":"ebe99320","promotion":"573597f8","salary_generate":"017beb09","salary_report":"00ce6005","salary_sheet":"84cd2151","shift_management":"60156431","transaction_record":"5e793184","access_denied":"31d6cfe0","attendance-process":"786d522a","chunk-5442ff1e":"218e3bfd","company_profile":"4fa657a9","employee-details":"da00aa01","holiday_management":"b39b2cc2","notice":"5675ced1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://butterflyenthr.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
